export const USA_ID = 893;

export const FLOW_BUILDINGS_IDS = [
  18496, // SLO prod
  10367, // SLO release
];
